__turbopack_context__.v({
  "mainGridContainer": "MainGridContainer-module-scss-module__zXtCWa__mainGridContainer",
  "mainGridContainerWithLeftGutter": "MainGridContainer-module-scss-module__zXtCWa__mainGridContainerWithLeftGutter",
  "mainGridContainerWithNoGutter": "MainGridContainer-module-scss-module__zXtCWa__mainGridContainerWithNoGutter",
  "mainGridContainerWithRightGutter": "MainGridContainer-module-scss-module__zXtCWa__mainGridContainerWithRightGutter",
});
